import { createClient } from '@supabase/supabase-js'
import { supabase } from './supabase'

// Admin client with service role for bypassing RLS
export const adminSupabase = createClient(
  import.meta.env.VITE_SUPABASE_URL || 'https://jzywrnhfrxlnsbktnnwo.supabase.co',
  import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp6eXdybmhmcnhsbnNia3RubndvIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1MzkwOTI1NiwiZXhwIjoyMDY5NDg1MjU2fQ.1J_Q8lYAI872eC4sHnBVOoi4zTFcuw09PZUkf59YvUY',
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false
    }
  }
)

// Check if user is admin
export const isAdminAuthenticated = async (): Promise<boolean> => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) return false
    
    const adminEmails = [
      'admin@petunyaborek.com',
      'manager@petunyaborek.com',
      'siparisler@petunyaborek.com',
      'yonetim@petunyaborek.com'
    ]
    
    return adminEmails.includes(user.email || '')
  } catch (error) {
    console.error('Admin authentication check error:', error)
    return false
  }
}